import React from 'react';
import styled from 'styled-components';
import {
  ModalTitle as GlobalModalTitle,
  ModalBody
} from './common/modal/ModalComponents';
import Modal from './common/modal/Modal';

const IconContainer = styled.div`
  width: 60px;
  height: 60px;
  background-color: #fff5f5;
  color: #e53e3e;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  margin: 0 auto 1.5rem;
`;

const Message = styled.p`
  margin: 0 0 2rem;
  color: #718096;
  line-height: 1.5;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 1rem;
`;

const Button = styled.button<{ variant?: 'danger' | 'secondary' }>`
  flex: 1;
  padding: 0.75rem;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  border: none;

  ${props => props.variant === 'danger' && `
    background-color: #e53e3e;
    color: white;
    &:hover { background-color: #c53030; }
  `}

  ${props => props.variant === 'secondary' && `
    background-color: #edf2f7;
    color: #4a5568;
    &:hover { background-color: #e2e8f0; }
  `}
`;

interface ConfirmModalProps {
  isOpen: boolean;
  title: string;
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
  confirmLabel?: string;
  cancelLabel?: string;
  isLoading?: boolean;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  isOpen,
  title,
  message,
  onConfirm,
  onCancel,
  confirmLabel = 'Confirmar',
  cancelLabel = 'Cancelar',
  isLoading = false
}) => {
  if (!isOpen) return null;

  return (
    <Modal isOpen={isOpen} onClose={onCancel} maxWidth="400px">
        <ModalBody>
          <IconContainer>
            <i className="fas fa-exclamation-triangle"></i>
          </IconContainer>
          <GlobalModalTitle style={{ marginBottom: '0.75rem', fontSize: '1.25rem' }}>{title}</GlobalModalTitle>
          <Message>{message}</Message>
          <ButtonGroup>
            <Button variant="secondary" onClick={onCancel} disabled={isLoading}>
              {cancelLabel}
            </Button>
            <Button variant="danger" onClick={onConfirm} disabled={isLoading}>
              {isLoading ? 'Aguarde...' : confirmLabel}
            </Button>
          </ButtonGroup>
        </ModalBody>
    </Modal>
  );
};

export default ConfirmModal;
